import { Navigate, Route, Routes } from "react-router";
import { routePaths } from "./constants/paths";
import LoginPage from "./pages/auth/Login";
import SignupPage from "./pages/auth/Signup";
import RootLayout from "./components/layouts/RootLayout";
import DashboardPage from "./pages/dashboard";
import DashboardLayout from "./components/layouts/DashboardLayout";
import RegisterPage from "./pages/register";
import AuthLayout from "./components/layouts/AuthLayout";
import SharedViewPage from "./pages/shared/SharedViewPage";
import MeterLookupPage from "./pages/public/MeterLookupPage";

export default function AppRoutes() {
  return (
    <RootLayout>
      <Routes>
        <Route index element={<Navigate to={routePaths.login} />} />
        <Route path={routePaths.login} element={<LoginPage />} />
        <Route path={routePaths.signup} element={<SignupPage />} />
        {/* Public shared view route - no auth required */}
        <Route path={routePaths.shared} element={<SharedViewPage />} />
        {/* Public QR meter lookup - no auth required */}
        <Route path={routePaths.meterLookup} element={<MeterLookupPage />} />
        <Route element={<DashboardLayout />}>
          <Route
            path={routePaths.dashboard}
            element={
              <AuthLayout>
                <DashboardPage />
              </AuthLayout>
            }
          />
          <Route
            path={routePaths.register}
            element={
              <AuthLayout>
                <RegisterPage />
              </AuthLayout>
            }
          />
        </Route>
      </Routes>
    </RootLayout>
  );
}
